import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/game-shot-charts.widget.module.scss";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const GameShotChartWidgetAsyncComponent = AsyncComponent(async () => import('./game-shot-charts.widget' /* webpackChunkName: "shot-charts.widget" */ ));

export const GameShotChartsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={props.isFullView}>
    {
      props.shouldUseSuspense ? <React.Suspense fallback={<div className={classNames(styles.placeholder, props.className)}/>}>
        <GameShotChartWidgetAsyncComponent {...props}/>
      </React.Suspense> : <GameShotChartWidgetAsyncComponent {...props}/>
    }
  </ErrorBoundaryWrapper>
};